module.exports = "/ui/2cbca10e800dfcc4887cecbc6b5f8823.png";